// Copyright © 2023 Move Closer

export enum SearchOptionType {
  Departments = 'departments',
  Locations = 'locations',
  JobModel = 'jobModel',
  TextQuery = 'textQuery'
}
